import { useTranslations as useNextIntlTranslations } from 'next-intl'
import en from '../../locales/en/translations.json'

// Derive the type for translations
type Messages = typeof en

// Extract keys whose values are objects (valid namespaces)
type ObjectKeys<T> = {
  [K in keyof T]: T[K] extends object ? K : never
}[keyof T]

export type TranslationFunction = ReturnType<typeof useNextIntlTranslations>

// Combine namespace and top-level key inference
export const useTranslations = <N extends ObjectKeys<Messages> | undefined = undefined>(
  namespace?: N,
) => {
  // Always call the hook
  return useNextIntlTranslations(namespace && namespace)
}
